import { defineMessages } from 'react-intl';

export const messages: Record<
	string,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	title: {
		id: 'conversation-assistant-message-actions.controllers.jira-board-start-sprint.title',
		defaultMessage: 'Start sprint',
		description: 'Heading shown at the top of the start sprint action card in Rovo chat.',
	},
	completeTitle: {
		id: 'conversation-assistant-message-actions.controllers.jira-board-start-sprint.completeTitle',
		defaultMessage: 'Complete sprint',
		description:
			'Heading shown at the top of the action card in Rovo chat when the sprint is being completed (i.e. its state is closed).',
	},
	nameLabel: {
		id: 'conversation-assistant-message-actions.controllers.jira-board-start-sprint.nameLabel',
		defaultMessage: 'Name',
		description: 'Label for the sprint name detail row in the start sprint action card.',
	},
	startDateLabel: {
		id: 'conversation-assistant-message-actions.controllers.jira-board-start-sprint.startDateLabel',
		defaultMessage: 'Start date',
		description: 'Label for the start date detail row in the start sprint action card.',
	},
	endDateLabel: {
		id: 'conversation-assistant-message-actions.controllers.jira-board-start-sprint.endDateLabel',
		defaultMessage: 'End date',
		description: 'Label for the end date detail row in the start sprint action card.',
	},
	confirmButton: {
		id: 'conversation-assistant-message-actions.controllers.jira-board-start-sprint.confirmButton',
		defaultMessage: 'Confirm',
		description:
			'Label for the confirm button in the start sprint action card that submits the action.',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.controllers.jira-board-start-sprint.cancelButton',
		defaultMessage: 'Cancel',
		description:
			'Label for the cancel button in the start sprint action card that dismisses the action.',
	},
});
